import React, {useState, useEffect, useRef} from 'react';

import styles from './index.less';
import {Link} from "react-router-dom";
import radarLog from "../../static/util/radar";

export default function OperationCard(props) {
  const {
    isMobile = false,
    img_booths = [
      // {img:'https://pub-shbt.s3.360.cn/zhike-admin/image3500.png',url:'https://baidu.com'},
      // {img:'https://pub-shbt.s3.360.cn/zhike-admin/image3500.png',url:'https://baidu.com'},
      // {img:'https://pub-shbt.s3.360.cn/zhike-admin/image3500.png',url:'https://baidu.com'},
      // {img:'https://pub-shbt.s3.360.cn/zhike-admin/image3500.png',url:'https://baidu.com'},
    ],
    text_booths = [
      // {img:'https://pub-shbt.s3.360.cn/zhike-admin/image3500.png',url:'https://baidu.com',text:'操作手册操作手册操作手册操作手册操作手册操作手册'},
      // {img:'https://pub-shbt.s3.360.cn/zhike-admin/image3500.png',url:'https://baidu.com',text:'操作手册操作手册操作手册操作手册操作手册操作手册'},
      // {img:'https://pub-shbt.s3.360.cn/zhike-admin/image3500.png',url:'https://baidu.com',text:'操作手册操作手册操作手册操作手册操作手册操作手册'},
      // {img:'https://pub-shbt.s3.360.cn/zhike-admin/image3500.png',url:'https://baidu.com',text:'操作手册操作手册操作手册操作手册操作手册操作手册'},
    ],
    color,
  } = props;


  const render = () => {
    return <div className={`${styles['container']} container-rd container-sd`}>
      <div className={styles['header']} style={{background: color}}>
        <p>推荐</p>
      </div>
      <div className={styles['contents']}>
        {
          img_booths && img_booths.map(item => {
            if (item.url) {
              return <Link target={"_blank"} to={item.url}><img className={styles['img-item']} src={item.img} onClick={() => radarLog({ c: 'user_click' })}/></Link>
            }
            return <img className={styles['img-item']} src={item.img} onClick={() => radarLog({ c: 'user_click_unopen' })}/>
          })
        }
        {
          text_booths && text_booths.map(item => {
            if (item.url) {
              return <Link target={"_blank"} to={item.url}>
                <div style={{padding: '2px 4px'}} onClick={() => radarLog({ c: 'user_click' })}>
                  <div className={styles['text-item']}>
                    <p className={styles['text']}>{item.text}</p>
                    <svg className={`icon ${styles.icon}`} aria-hidden="true">
                      <use xlinkHref={`#icon-zhike-bianzu2`}/>
                    </svg>
                  </div>
                </div>
              </Link>
            }
            return <div style={{padding: '2px 4px'}} onClick={() => radarLog({ c: 'user_click_unopen' })}>
              <div className={styles['text-item']}>
                <p className={styles['text']}>{item.text}</p>
                <svg className={`icon ${styles.icon}`} aria-hidden="true">
                  <use xlinkHref={`#icon-zhike-bianzu2`}/>
                </svg>
              </div>
            </div>
          })
        }

      </div>
    </div>
  };
  return render()
}